import styled from 'styled-components/macro';

export const EmptySearchResult = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 26px;

  height: 300px;
`;

export const VideoThumbnail = styled.div`
  display: flex;
  border-radius: 10px;
  width: 79px;
  overflow: hidden;
  border: 1px solid ${props => props.theme.colors.neutral[40]};
  position: relative;
`;

export const VideoThumbnailSource = styled.img`
  width: 100%;
  height: 60px;
  object-fit: cover;
`;

export const TwoLineVideoTitle = styled.div`
  height: 35px;
  max-width: 135px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 14px;
  font-weight: 500;
`;

export const CustomInfoMessage = styled.div`
  color: ${props => props.theme.colors.primary[100]};
  font-size: 12px;
`;
